import { createApp } from 'vue';
import MkvToWavConverter from '@/Components/MkvToWavConverter.vue';
import '@styles/app.css';

createApp(MkvToWavConverter).mount('#mkv-to-wav-converter');
